import { render, staticRenderFns } from "./QrCode.vue?vue&type=template&id=08dbaed5&scoped=true&"
import script from "./QrCode.vue?vue&type=script&lang=js&"
export * from "./QrCode.vue?vue&type=script&lang=js&"
import style0 from "./QrCode.vue?vue&type=style&index=0&id=08dbaed5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08dbaed5",
  null
  
)

export default component.exports